/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Per-organization sampling settings for skill efficacy scoring.
 */
export type SkillEfficacySettings = {
  /**
   * Whether skill efficacy scoring is enabled.
   */
  enabled: boolean;
  /**
   * Whether these values are platform defaults rather than stored organization settings.
   */
  isDefault: boolean;
  /**
   * Lifetime evaluations a new skill version may reserve before the per-skill daily cap applies.
   */
  newVersionBurst: number;
  /**
   * Maximum evaluations reserved across the organization each UTC day.
   */
  orgDailyCap: number;
  /**
   * Organization these settings apply to.
   */
  organizationId: string;
  /**
   * Maximum evaluations reserved per skill each UTC day.
   */
  perSkillDailyCap: number;
};

/** @internal */
export const SkillEfficacySettings$inboundSchema: z.ZodMiniType<
  SkillEfficacySettings,
  unknown
> = z.pipe(
  z.object({
    enabled: z.boolean(),
    is_default: z.boolean(),
    new_version_burst: z.int(),
    org_daily_cap: z.int(),
    organization_id: z.string(),
    per_skill_daily_cap: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "is_default": "isDefault",
      "new_version_burst": "newVersionBurst",
      "org_daily_cap": "orgDailyCap",
      "organization_id": "organizationId",
      "per_skill_daily_cap": "perSkillDailyCap",
    });
  }),
);

export function skillEfficacySettingsFromJSON(
  jsonString: string,
): SafeParseResult<SkillEfficacySettings, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillEfficacySettings$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillEfficacySettings' from JSON`,
  );
}
